import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useMarketingMaster } from "../../store/marketing/reducer";
import { useSlotsMaster } from "../../store/slots/reducer";
import { REQUEST_DELETE_MASTER_SLOTS } from "../../store/slots/slotsActionTypes";
import slots from "../../store/slots/reducer";

interface SlotDeleteProps {
  slotData: any;
  isDeleteOpen: boolean;
  onDeleteClose: () => void;
  selectedRestaurant: any;
  selectedTime: any;
  onSlotsUpdate: () => void;
}

const SlotDeleteConfirmation: React.FC<SlotDeleteProps> = ({
  isDeleteOpen,
  onDeleteClose,
  slotData,
  selectedRestaurant,
  selectedTime,
  onSlotsUpdate,
}) => {
  const dispatch = useDispatch();
  const { busy, message } = useSlotsMaster();
  const toast = useToast();

  // useEffect(() => {
  //   const slotExists = Object.values(events).some((mealSlots) =>
  //     (mealSlots as any[]).some((slot: any) =>
  //       slot.slots.some((timeSlot: any) => timeSlot._id === slotData._id)
  //     )
  //   );
  //   if (!slotExists) {
  //     toast({
  //       title: "Success.",
  //       description: "post is deleted.",
  //       status: "success",
  //       isClosable: true,
  //       position: "top-right",
  //     });
  //     onClose();
  //   }
  // }, [slotData, events, onClose]);

  const handleDelete = () => {
    dispatch({
      type: REQUEST_DELETE_MASTER_SLOTS,
      payload: {
        _id: slotData.slotId,
        restaurantId: selectedRestaurant,
        type: selectedTime,
      },
      onSuccess: () => {
        toast({
          title: "Success",
          description: "Slot has been deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
        onSlotsUpdate();
        onDeleteClose();
      },
      onError: (error: any) => {
        toast({
          title: "Error",
          description: error?.message || "Failed to delete slot.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      },
    });
  };
  return (
    <Modal
      isOpen={isDeleteOpen}
      onClose={onDeleteClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Post</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this slot?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={onDeleteClose}
            disabled={busy}
          >
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            // onClick={() => {
            //   dispatch({
            //     type: REQUEST_DELETE_MASTER_SLOTS,
            //     payload: {
            //       _id: slotData._id,
            //       restaurantId: selectedRestaurant,
            //       type: selectedTime,
            //     },
            //     onSuccess: () => {
            //       toast({
            //         title: "Success",
            //         description: "Slot has been deleted successfully.",
            //         status: "success",
            //         duration: 3000,
            //         isClosable: true,
            //         position: "top-right",
            //       });
            //       onDeleteClose();
            //     },
            //     onError: (error: any) => {
            //       toast({
            //         title: "Error",
            //         description: error?.message || "Failed to delete slot.",
            //         status: "error",
            //         duration: 3000,
            //         isClosable: true,
            //         position: "top-right",
            //       });
            //     },
            //   });
            //   // onClose();
            // }}
            onClick={handleDelete}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default SlotDeleteConfirmation;
